import { render, staticRenderFns } from "./EditAgents.vue?vue&type=template&id=0d563ee8&scoped=true"
import script from "./EditAgents.vue?vue&type=script&lang=js"
export * from "./EditAgents.vue?vue&type=script&lang=js"
import style0 from "./EditAgents.vue?vue&type=style&index=0&id=0d563ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d563ee8",
  null
  
)

export default component.exports